export const getCoins = (state) => state.setting.coins;
export const getCurrencyMarkets = (state) => state.setting.currencyMarkets;
